import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
import TextField from '@mui/material/TextField';

import { getMinimumpaymentAmount } from '../util/settings';
import {
  updatePaymentAmount as onUpdatePaymentAmount,
  updatePaymentAmountType as onUpdatePaymentAmountType,
} from '../actions/payment-actions';
import { setTestId } from '../util/testUtils';
import paymentAmountTypes from '../constants/payment-amount-type-constants';

const useStyles = makeStyles((theme) => ({
  amountInput: {
    textAlign: 'right',
  },
  inputCell: {
    marginTop: theme.spacing(8),
    minHeight: theme.spacing(8),
  },
  textFieldStyle: {
    marginBottom: theme.spacing(1),
    // Fix IE display
    width: '100%',
  },
}));

function PaymentAmountControl(props) {
  const {
    handleUpdatePaymentAmountType,
    handleUpdatePaymentAmount,
    balanceDue,
    paymentAmount,
    paymentAmountError,
    paymentAmountType,
  } = props;

  const handlePaymentAmountType = (event) => {
    handleUpdatePaymentAmountType(event.target.value);
  };

  const handleUpdateAmount = (event) => {
    handleUpdatePaymentAmount(event.target.value);
  };

  const classes = useStyles();

  const roundedBal = balanceDue.toFixed(2);
  const showPartialAmount = roundedBal > getMinimumpaymentAmount();

  return (
    <Grid className={classes.paymentMethod} container>
      <Grid item xs={8}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Payment Amount</FormLabel>
          <RadioGroup
            name="paymentMethod"
            onChange={handlePaymentAmountType}
            value={paymentAmountType}
          >
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  {...setTestId('paymentAmountTypeFull')}
                />
              }
              label={`Full Amount ($${roundedBal})`}
              value={paymentAmountTypes.FULL}
            />
            {showPartialAmount && (
              <FormControlLabel
                control={
                  <Radio
                    color="primary"
                    {...setTestId('paymentAmountTypePartial')}
                  />
                }
                label="Other amount"
                value={paymentAmountTypes.PARTIAL}
              />
            )}
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid className={classes.inputCell} item xs={4}>
        {paymentAmountType === paymentAmountTypes.PARTIAL && (
          <TextField
            autoFocus
            {...setTestId('paymentAmount')}
            className={classes.textFieldStyle}
            error={Boolean(paymentAmountError)}
            helperText={paymentAmountError}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
              className: classes.amountInput,
              inputProps: { className: classes.amountInput },
            }}
            name="amount"
            onChange={handleUpdateAmount}
            placeholder={roundedBal}
            value={paymentAmount}
          />
        )}
      </Grid>
    </Grid>
  );
}

function mapStateToProps(state) {
  const { paymentAmountType, paymentAmount, paymentAmountError } =
    state.payment;
  return {
    paymentAmountType,
    paymentAmount,
    paymentAmountError,
    balanceDue: state.invoice.balanceDue,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleUpdatePaymentAmountType: onUpdatePaymentAmountType,
      handleUpdatePaymentAmount: onUpdatePaymentAmount,
    },
    dispatch
  );
}
PaymentAmountControl.propTypes = {
  balanceDue: PropTypes.number.isRequired,
  handleUpdatePaymentAmount: PropTypes.func.isRequired,
  handleUpdatePaymentAmountType: PropTypes.func.isRequired,
  paymentAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  paymentAmountError: PropTypes.string,
  paymentAmountType: PropTypes.string.isRequired,
};

PaymentAmountControl.defaultProps = {
  paymentAmountError: null,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentAmountControl);
